import { Component } from '@angular/core';

@Component({
  selector: 'app-user-profile-social-security',
  imports: [],
  templateUrl: './user-profile-social-security.component.html',
})
export class UserProfileSocialSecurityComponent {}
